"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var address_value_1 = require("./../../../shared/model/address-value");
var auto_eletric_service_1 = require("../../../shared/service/auto-eletric.service");
var router_1 = require("@angular/router");
var auto_eletric_1 = require("../../../shared/model/auto-eletric");
var take_mode_1 = require("../../../shared/model/take-mode");
var technician_1 = require("../../../shared/model/technician");
var provided_service_service_1 = require("../../../shared/service/provided-service.service");
var address_1 = require("../../../shared/model/address");
var cnpj_pipe_1 = require("../../../shared/pipe/cnpj.pipe");
var cep_pipe_1 = require("../../../shared/pipe/cep.pipe");
var auto_eletric_provided_service_1 = require("../../../shared/model/auto-eletric-provided-service");
var save_http_error_1 = require("../../../shared/error/save-http-error");
var update_http_error_1 = require("../../../shared/error/update-http-error");
var toast_service_1 = require("../../../shared/service/toast.service");
var AutoEletricCreateUpdateComponent = /** @class */ (function () {
    function AutoEletricCreateUpdateComponent(_autoEletricService, _providedServiceService, _route, _router, _toastService) {
        this._autoEletricService = _autoEletricService;
        this._providedServiceService = _providedServiceService;
        this._route = _route;
        this._router = _router;
        this._toastService = _toastService;
        this.hasDeliveryAddress = false;
        this.actionDeliveryLabel = 'ADICIONAR';
        this.editMode = false;
        this.setEmptyAutoEletric();
        this.setPipes();
        this.editModeVerify();
        this.setUpObservers();
        this.findProvidedServices();
    }
    AutoEletricCreateUpdateComponent.prototype.save = function () {
        if (!this.newAutoEletric.address.number.trim()) {
            this.newAutoEletric.address.number = address_value_1.AddressValue.WITHOUT_NUMBER;
        }
        if (this.editMode) {
            this._autoEletricService.update(this.newAutoEletric);
        }
        else {
            this._autoEletricService.save(this.newAutoEletric);
        }
    };
    AutoEletricCreateUpdateComponent.prototype.editModeVerify = function () {
        var _this = this;
        this.partialTitle = 'Cadastrar ';
        this._route.params.subscribe(function (params) {
            if (params['id']) {
                _this.editMode = true;
                _this.autoEletricId = +params['id'];
                _this._autoEletricService.findById(_this.autoEletricId);
                _this.partialTitle = 'Editar ';
            }
        });
    };
    AutoEletricCreateUpdateComponent.prototype.setPipes = function () {
        this.cnpjPipe = new cnpj_pipe_1.CnpjPipe();
        this.cepPipe = new cep_pipe_1.CepPipe();
    };
    AutoEletricCreateUpdateComponent.prototype.setEmptyAutoEletric = function () {
        this.newAutoEletric = new auto_eletric_1.AutoEletric();
        this.newAutoEletric.address = new address_1.Address();
        this.setUpTechnicians();
        this.setUpAutoEletricServices();
        this.takeModes = new Array();
        this.removeDeliveryAddress();
    };
    AutoEletricCreateUpdateComponent.prototype.ngOnInit = function () {
    };
    AutoEletricCreateUpdateComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    AutoEletricCreateUpdateComponent.prototype.setUpObservers = function () {
        this.setUpFindAction(this._autoEletricService.find$);
        this.setUpSaveUpdateAction(this._autoEletricService.save$);
        this.setUpSaveUpdateAction(this._autoEletricService.update$);
        this.setUpErrorAction(this._autoEletricService.error$);
        this.getTakeModes();
    };
    AutoEletricCreateUpdateComponent.prototype.setUpFindAction = function (observable) {
        var _this = this;
        observable
            .filter(function (autoEletric) { return autoEletric instanceof auto_eletric_1.AutoEletric; })
            .subscribe(function (autoEletric) {
            _this.newAutoEletric = autoEletric;
            if (_this.newAutoEletric.deliveryAddress) {
                _this.hasDeliveryAddress = true;
                _this.actionDeliveryLabel = _this.hasDeliveryAddress ? 'REMOVER' : 'ADICIONAR';
            }
        });
    };
    AutoEletricCreateUpdateComponent.prototype.setUpErrorAction = function (observable) {
        var _this = this;
        observable
            .filter(function (error) { return error instanceof save_http_error_1.SaveHttpError || error instanceof update_http_error_1.UpdateHttpError; })
            .subscribe(function (error) { return _this._toastService.showMessage(error.text, 4000); });
    };
    AutoEletricCreateUpdateComponent.prototype.setUpTechnicians = function () {
        this.newAutoEletric.technicians = new Array();
        this.addTechnician();
    };
    AutoEletricCreateUpdateComponent.prototype.setUpAutoEletricServices = function () {
        this.newAutoEletric.autoEletricServices = new Array();
        this.addProvidedService();
    };
    AutoEletricCreateUpdateComponent.prototype.setUpSaveUpdateAction = function (observable) {
        var _this = this;
        observable
            .subscribe(function () {
            _this.goBack();
        });
    };
    AutoEletricCreateUpdateComponent.prototype.getTakeModes = function () {
        var _this = this;
        this._autoEletricService.findAllTakeModes()
            .subscribe(function (takeModes) { return _this.takeModes = _this.takeModesValuesList(takeModes); }, function (error) {
            // Show message error on previous page
            _this.goBack();
        });
    };
    AutoEletricCreateUpdateComponent.prototype.findProvidedServices = function () {
        var _this = this;
        this._providedServiceService.findAll()
            .subscribe(function (providedServices) { return _this.providedServices = providedServices; });
    };
    AutoEletricCreateUpdateComponent.prototype.goBack = function () {
        this._router.navigate(['auto_eletrics/list']);
    };
    AutoEletricCreateUpdateComponent.prototype.setTakeMode = function (value) {
        this.newAutoEletric.takeMode = value;
    };
    AutoEletricCreateUpdateComponent.prototype.setAutoEletricAddressState = function (value) {
        this.newAutoEletric.address.state = value;
    };
    AutoEletricCreateUpdateComponent.prototype.setAutoEletricDeliveryAddressState = function (value) {
        this.newAutoEletric.deliveryAddress.state = value;
    };
    AutoEletricCreateUpdateComponent.prototype.addTechnician = function () {
        this.newAutoEletric.technicians.push(new technician_1.Technician());
    };
    AutoEletricCreateUpdateComponent.prototype.addProvidedService = function () {
        this.newAutoEletric.autoEletricServices.push(new auto_eletric_provided_service_1.AutoEletricProvidedService());
    };
    AutoEletricCreateUpdateComponent.prototype.removeLastTechnician = function () {
        if (this.newAutoEletric.technicians.length > 1) {
            this.newAutoEletric.technicians = this.newAutoEletric.technicians.slice(0, -1);
        }
    };
    AutoEletricCreateUpdateComponent.prototype.removeLastProvidedService = function () {
        if (this.newAutoEletric.autoEletricServices.length > 1) {
            this.newAutoEletric.autoEletricServices = this.newAutoEletric.autoEletricServices.slice(0, -1);
        }
    };
    AutoEletricCreateUpdateComponent.prototype.takeModesValuesList = function (takeModes) {
        var takeModesList = [];
        Object.keys(takeModes).forEach(function (key) {
            takeModesList.push(new take_mode_1.TakeMode(key, takeModes[key]));
        });
        return takeModesList;
    };
    AutoEletricCreateUpdateComponent.prototype.getTakeModeFromKey = function (key) {
        return this.takeModes.find(function (takeMode) { return takeMode.key === key; }).value;
    };
    AutoEletricCreateUpdateComponent.prototype.applyCnpjMask = function (event) {
        this.newAutoEletric.cnpj = this.cnpjPipe.transform(event.target.value, event.key);
    };
    AutoEletricCreateUpdateComponent.prototype.applyCepMask = function (event) {
        return this.cepPipe.transform(event.target.value, event.key);
    };
    AutoEletricCreateUpdateComponent.prototype.toggleDeliveryAddressForm = function () {
        this.hasDeliveryAddress = !this.hasDeliveryAddress;
        if (this.hasDeliveryAddress) {
            this.actionDeliveryLabel = 'REMOVER';
            this.addDeliveryAddress();
        }
        else {
            this.actionDeliveryLabel = 'ADICIONAR';
            this.removeDeliveryAddress();
        }
    };
    AutoEletricCreateUpdateComponent.prototype.addDeliveryAddress = function () {
        this.newAutoEletric.deliveryAddress = new address_1.Address();
    };
    AutoEletricCreateUpdateComponent.prototype.removeDeliveryAddress = function () {
        this.newAutoEletric.deliveryAddress = null;
    };
    AutoEletricCreateUpdateComponent.ctorParameters = function () { return [{ type: auto_eletric_service_1.AutoEletricService }, { type: provided_service_service_1.ProvidedServiceService }, { type: router_1.ActivatedRoute }, { type: router_1.Router }, { type: toast_service_1.ToastService }]; };
    return AutoEletricCreateUpdateComponent;
}());
exports.AutoEletricCreateUpdateComponent = AutoEletricCreateUpdateComponent;
//# sourceMappingURL=auto-eletric-create-update.component.js.map


// WEBPACK FOOTER //
// auto-eletric-create-update.component.js